import { createElement } from "react";
import type { ExtensionInstallation, OrganizationScope } from "@/lib/api";
import { ExtensionCostingReview, type ExtensionCostingReviewProps } from "./ExtensionCostingReview";

const WORKPAPER_PANEL_SLOT = "accounting.workpaper-panel.v1";

function v2CloseView(installation: ExtensionInstallation): string | null {
  if (installation.api_version !== "2.0" || !installation.v2) return null;
  for (const value of installation.v2.ui ?? []) {
    if (!value || typeof value !== "object") continue;
    const contribution = value as { app?: unknown; slot?: unknown; viewId?: unknown };
    if (
      contribution.app === "niche-accounting" &&
      contribution.slot === WORKPAPER_PANEL_SLOT &&
      typeof contribution.viewId === "string" &&
      contribution.viewId
    ) {
      return contribution.viewId;
    }
  }
  return null;
}

/** Host adapters are input-authoring workflows, not costing engines. The
 * extension's declared UI bundle is the contract; the host never rebuilds the
 * review form or guesses a release schema. */
export function closeInputWorkflow(installation: ExtensionInstallation, installations: ExtensionInstallation[]) {
  if (installation.state !== "enabled" || installation.publisher !== "sylviq" || installation.key !== "niche-cultivation-costing" || !installation.apps?.includes("niche-accounting")) return null;
  const dependencies = installations.filter(item => item.publisher === "sylviq" && item.key === "metrc-traceability" && item.version === "1.0.1" && item.state === "enabled" && item.apps?.includes("niche-accounting"));
  const dependencyInstallationId = dependencies.length === 1 ? dependencies[0]!.id : null;
  const viewId = v2CloseView(installation);
  if (viewId) {
    const Component = (props: ExtensionCostingReviewProps) =>
      createElement(ExtensionCostingReview, {
        ...props,
        installationId: installation.id,
        viewId,
      });
    return { title: "cultivation costing review", Component, dependencyInstallationId };
  }
  if (!installation.entrypoints.ui_view) return null;
  return { title: "cultivation costing review", Component: ExtensionCostingReview, dependencyInstallationId };
}

export function closeReviewScopeKey(scope: OrganizationScope | null, installation: ExtensionInstallation, license: string, start: string, end: string, dependency: string | null) {
  return JSON.stringify([scope?.organization_id, scope?.legal_entity_id, installation.id, installation.version, installation.apps, dependency, license, start, end]);
}
